

import { Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { separadorMillares } from "../../../hooks/useMillares";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useValidarRoles } from "../../../hooks";
import { useImagenStore, useModalStore } from "../../../stores";
import { eliminarAbonoOp } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";
import { fechaSinHora } from "../../../helpers/prepararFecha";

import Swal from "sweetalert2";




export const TablaAbonosAOP = ({ data }) => {


    const { isAdminRol } = useValidarRoles();
    const queryClient = useQueryClient();
    const { valorImagen } = useImagenStore();
    const { toggleModalImg } = useModalStore();
    

    const handleVerImg = (valor) => {
        valorImagen(valor);
        toggleModalImg(true);
    }



    const handleEliminarAbono = async(id) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Eliminar Abono',
            text: `¿Eliminar abono?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
        });

        if(!isConfirmed) return;
    
        const resp = await eliminarAbonoOp(id);
        if(resp) { 
            queryClient.invalidateQueries({ queryKey: ['op-id'] });
            queryClient.invalidateQueries({ queryKey: ['abonosxop'] });
        }
    }



    return (
        <>
        {(data?.length > 0)
        ?   <LayoutTabla>
                <TableHead >
                    <TableRow >
                        <TableCell sx={{width:'20%'}}>FECHA</TableCell>
                        <TableCell sx={{width:'20%'}}>ABONO</TableCell>
                        <TableCell sx={{width:'20%'}}>BANCO</TableCell>
                        <TableCell sx={{width:'25%'}}>OBSERVACIÓN</TableCell>
                        <TableCell sx={{width:'15%'}}>Usuario</TableCell>
                        {isAdminRol() && 
                        <TableCell sx={{width:'15%'}}>Opciones</TableCell>
                        }
                    </TableRow>
                </TableHead>

                <TableBody>
                {data.map( a => (
                    <TableRow key={a.id} >
                        <TableCell>{ fechaSinHora(a?.createdAt) }</TableCell>
                        <TableCell>{ `$${separadorMillares(a.abono)}` }</TableCell>
                        <TableCell>{ a.medio }</TableCell>
                        <TableCell>{ a.observacion }</TableCell>
                        <TableCell>{ (a.user)  ? a.user.nombre : 'No-Dato' }</TableCell>
                        {isAdminRol() && 
                        <TableCell>
                            <Stack direction="row" spacing={1} justifyContent="center">
                                <TooltipAndIcon
                                    titulo="Ver Imagen"
                                    icono="ver"
                                    color="white"
                                    onClick={ () => handleVerImg(a.img) }
                                />  

                                <TooltipAndIcon
                                    titulo="Eliminar Abono"
                                    icono="eliminar"
                                    color="red"
                                    onClick={ () => handleEliminarAbono(a.id) }
                                />  
                            </Stack>
                        </TableCell>
                        }
                    </TableRow>
                    ))
                }
                </TableBody>
            </LayoutTabla>
        :   <MensajeAlertaDanger titulo='No hay abonos en el momento' />
        }
        </>

    )
}
